import { RJSFSchema, schemaRequiresTrueValue, StrictRJSFSchema, WidgetProps } from '@rjsf/utils';
import { ChangeEvent, useCallback } from 'react';

import Checkbox from 'design-system/components/Checkbox';

/** The `CheckBoxWidget` is a widget for rendering boolean properties.
 *  It is typically used to represent a boolean.
 *
 * @param props - The `WidgetProps` for this component
 */
export function CheckboxWidget<T = any, S extends StrictRJSFSchema = RJSFSchema, F = any>({
  schema,
  id,
  value,
  disabled,
  readonly,
  label,
  autofocus = false,
  onChange,
}: /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
WidgetProps<T, S, F>) {
  // Because an unchecked checkbox will cause html5 validation to fail, only add
  // the "required" attribute if the field value must be "true", due to the
  // "const" or "enum" keywords
  const required = schemaRequiresTrueValue(schema);

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => onChange(event.target.checked),
    [onChange],
  );

  return (
    <Checkbox
      label={label}
      id={id}
      name={id}
      required={required}
      checked={value}
      disabled={disabled || readonly}
      autoFocus={autofocus}
      onChange={handleChange}
    />
  );
}
